import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { LoanDocumentType } from '../../../store/loanDocumentStore/types/LoanDocumentType';
import useNewLoanDocumentStore from '../../../store/loanDocumentStore/useNewLoanDocumentStore';
import { locator } from '../../../testing/e2e-locator/locator';
import { filesize } from './filesize';

type LoanDocumentListProps = {
  providedDocuments: LoanDocumentType[];
};

export const LoanDocumentList = ({
  providedDocuments,
}: LoanDocumentListProps): ReactNode => {
  const { t } = useTranslation();

  const { clearPreview, removeDocument } = useNewLoanDocumentStore();

  return (
    <ul
      className="loan-document-list"
      data-testid={locator.components.loanDocumentList.root}
    >
      {providedDocuments.map(
        (document: LoanDocumentType, index): ReactNode => (
          <li
            data-testid={locator.components.loanDocumentList.getDocumentItem(
              index,
            )}
            key={document.uniqueName}
          >
            {document.preview ? (
              <img
                alt={`Preview of ${document.file.name}`}
                src={document.preview}
                onError={(): void => {
                  clearPreview(document);
                }}
              />
            ) : (
              <UploadFileRoundedIcon />
            )}

            <div>
              <p className="name">{document.file.name}</p>
              <p className="size">{filesize(document.file.size)}</p>
            </div>
            <button
              type="button"
              onClick={(): void => {
                removeDocument(document);
              }}
            >
              {t('LoanDocumentUploadPage.remove')}
            </button>
          </li>
        ),
      )}
    </ul>
  );
};
